angular
    .module('festzelt-os.documents.templates')
    .factory('duplicateDocumentTemplate', [
        '$injector',
        ($injector) => new DuplicateDocumentTemplateWorkflow($injector)
    ]);

class DuplicateDocumentTemplateWorkflow {
    constructor($injector) {
        this.injector = $injector;
        this.state = $injector.get('$state');
        this.translate = $injector.get('$translate');
        this.alert = $injector.get('Alert');
        this.api = $injector.get('$http');

        this.level = 'highlight';
        this.order = 20;
        this.title = this.translate.instant('general.verbs.duplicate');
        this.icon = 'copy';
        this.key = 'duplicate-document-template';
    }

    action(documentTemplate, vm) {
        this.alert.animatedAlert(
            this.translate.instant('general.alerts.duplication_in_progress.title'),
            this.translate.instant('general.alerts.duplication_in_progress.content'),
            'loading',
            {
                showCancelButton: false,
                showConfirmButton: false,
                allowEscapeKey: false,
                allowOutsideClick: false,
                animationConfig: {
                    loop: true
                }
            }
        );

        this.api
            .post(`documents/templates/${documentTemplate.id}/duplicate`)
            .then(({data}) => {
                this.state.go('app.documents.templates.details', {
                    id: data.data.id
                });
                this.alert.hide();
                this.alert.success(
                    this.translate.instant('general.alerts.create_success.title'),
                    this.translate.instant('general.alerts.create_success.content')
                );
            })
            .catch((e) => {
                this.alert.hide();
                this.alert.handle(e);
                // this.alert.error(
                //     this.translate.instant('general.alerts.create_error.title'),
                //     this.translate.instant('general.alerts.create_error.content')
                // );
            })
    }
}



// WEBPACK FOOTER //
// ./src/app/pages/documents/templates/workflows/details/duplicate-template.js